import Vue from 'vue';
import iView from 'iview'
import Clipboard from 'clipboard';


let token='';
let sesionId='';
let getParam=function getParam(){
  var search = {};
  try {
    location.search
      .substr(1)
      .split('&')
      .forEach(function(item) {
        var s = item.split('=');
        search[s[0]] = s[1];
      });
  } catch (e) {
    // 抛出异常
    throw new Error(JSON.stringify(search));
  }
  return search;
};
token = getParam().token;
sesionId = getParam().sesionId;
var global = {
  url:location.host.indexOf("dev.") != -1||location.host.indexOf(":80") != -1? "http://dev.cnknowledge.com:8081/tsg":"http://pubadmin.cnknowledge.com/tsg",
  imgUrl:location.host.indexOf("dev.") != -1||location.host.indexOf(":80") != -1?'http://fdfs.cnknowledge.com/':"http://tsgfd.cnknowledge.com/",
  publishPeriod(num){
    let data=[{name:"年刊"},
              {name:"半年刊"},
              {name:"季刊",},
              {name:"双月刊",},
              {name:"月刊",},
              {name:"半月刊"},
              {name:"旬刊"},
              {name:"周刊"},
              {name:"周二刊"},
            ]
            if(num==""){
              return
            }
    return data[num-1].name;

  },

  //稿件状态
  articleStatus(status){
  	if(!status) return;
		let data=[
	  		{name:'未支付'},
	  		{name:'待初审'},
	  		{name:'待查重'},
	  		{name:'待复审分配'},
	  		{name:'待复审'},
	  		{name:'待终审'},
	  		{name:'待外审分配'},
	  		{name:'待外审'},
	  		{name:'退修'},
	  		{name:'退稿'},
	  		{name:'待看板'},
	  		{name:'待看板确认'},
	  		{name:'待上传终稿'},
	  		{name:'待排期'},
	  		{name:'待发排'},
	  		{name:'待排版'},
	  		{name:'一校'},
	  		{name:'一改'},
	  		{name:'二校'},
	  		{name:'二改'},
	  		{name:'三校'},
	  		{name:'三改'},
	  		{name:'待出片'},
	  		{name:'待改片'},
	  		{name:'待印刷'},
	  		{name:'待邮寄'},
	  		{name:'录用'},
	  		{name:'审核中'},
	  		{name:'已撤稿'},
	  		{name:'已刊发'},
	  	]
	  	return data[status].name;
  },
  getParam:getParam,// 获取url参数返回json
  checkPhone(value){//验证手机号
    if(value==''){
      iView.Message.warning('手机号不能为空');
      return false;
    }
    if(!(/^1[3456789]\d{9}$/.test(value))){
      iView.Message.warning('手机号格式不对');
      return false;
    }
    return true;
  },
  transferDate(times){//时间戳转时间
    var date = new Date(times);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds();
    return Y+M+D+h+m+s;
  },
  transferYear(times){//时间戳转时间年月日
    var date = new Date(times);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
    return Y+M+D;
  },
  getYear(times){//时间戳转时间年月
    if(!times) return '';
    var date = new Date(times);
    var Y = date.getFullYear();
    return String(Y);
  },
  transferMonth(times){//时间戳转时间年月
    var date = new Date(times);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
    return Y+M;
  },
  transferTime(times){//时间转时间戳
    return new Date(times).getTime();
  },
  copyArr(arr){//拷贝数组
    return Object.assign([], arr)
  },
  copyObj(obj){//拷贝对象
    return Object.assign({}, obj)
  },
  copy(mobile){
      var Url = mobile;
      console.log(Url)
      var clipboard = new Clipboard('.tag-read', {
          text: function() {
              return Url;
          }
      });
      clipboard.on('success', e => {
        iView.Message.success('复制成功');
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        iView.Message.warning('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy()
      })
  },
  getGradeName(gradeId){
      if(gradeId==7){
          return '初一'
      }
      if(gradeId==8){
          return '初二'
      }
      if(gradeId==9){
          return '初三'
      }
  },
  sortByKey(array,key){  //(数组、排序的列)
      return array.sort(function(a,b){
          var x=a[key];
          var y=b[key];
          return ((x<y)?-1:((x>y)?1:0));
      });
  },
  // 保存用户信息
  saveUserInfo(info){
    var userInfo=JSON.parse(sessionStorage.getItem("userInfo"));//取出sesion
    userInfo.info=info;
    var jsonStr = JSON.stringify(userInfo);
    sessionStorage.setItem('userInfo', jsonStr);//将用户信息存入sesion
  },
}

// 注册插件全局通用
export default {
  install() {
    Vue.prototype.$global = global;
  },
  global
}



// WEBPACK FOOTER //
// ./src/core/global/global.js